(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name unicatalog.directive:catalogEditor
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="unicatalog">
       <file name="index.html">
        <catalog-editor></catalog-editor>
       </file>
     </example>
   *
   */
  angular
    .module('unicatalog')
    .directive('catalogEditor', catalogEditor);


  catalogEditor.$inject = ['Unicatalogtree', 'Unicatalog', '$log'];

  function catalogEditor(Unicatalogtree, Unicatalog, $log) {
    return {
      restrict: 'EA',
      scope: {},
      templateUrl: 'unicatalog/catalog-editor-directive.tpl.html',
      replace: false,
      controllerAs: 'cateCtrl',
      bindToController: true,
      controller: function () {
        var vm = this;
        vm.name = 'catalogEditor';

        vm.catalog = Unicatalogtree.$find('unicatalog');
        vm.allcatitems = Unicatalog.$search();


        vm.newGroup = function () {
          if (!angular.isArray(vm.catalog.groups)){
            vm.catalog.groups = [];
          }
          vm.catalog.groups.push({
            label: 'Neue Gruppe',
            items: []
          });
        };

        vm.newSubItem = function (scope) {
          var nodeData = scope.$modelValue;
          Unicatalog.$create().$asPromise().then(function (newitem){
            nodeData.items.push(newitem);
          });
        };

        vm.remove = function (scope) {
          scope.remove();
          vm.tpl.$save();
        };


      },
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
